module.exports = __webpack_public_path__ + "img/nicole-witt.a8f441aa.jpeg";